import type { Extensions } from '@tiptap/core'
import type { EditorAdapter } from './adapter'
import { IssueRef } from '../extensions/issue-reference'
import { IssueSuggestion } from '../extensions/issue-suggestion'
import { ResourceRef } from '../extensions/resource-ref'
import { UserMention } from '../extensions/user-mention'
import { rmDataSources } from '../utils/redmine'

export class GenericAdapter implements EditorAdapter {
  readonly context = 'generic' as const
  readonly attachmentsContainerSelector = '.attachments_fields'

  constructor(
    private readonly meta: HTMLElement,
    private readonly fieldId: string,
  ) { }

  get textareaSelector(): string {
    return `#${CSS.escape(this.fieldId)}`
  }

  get previewUrl(): string | undefined {
    return this.meta.dataset.previewUrl || undefined
  }

  get uploadPath(): string {
    return document.querySelector<HTMLInputElement>('input.filedrop')
      ?.dataset
      .uploadPath ?? '/uploads.js'
  }

  get userMentionUrl(): string | null {
    return this.meta.dataset.userMentionUrl
      || rmDataSources()?.users
      || null
  }

  get issueSuggestionUrl(): string | null {
    return rmDataSources()?.issues || null
  }

  get wikiPageSuggestionUrl(): string | null {
    return null
  }

  get extensions(): Extensions {
    const exts: Extensions = [IssueRef, ResourceRef]
    if (this.issueSuggestionUrl)
      exts.push(IssueSuggestion.configure({ url: this.issueSuggestionUrl }))
    if (this.userMentionUrl)
      exts.push(UserMention.configure({ url: this.userMentionUrl }))
    return exts
  }
}
